// extracted by mini-css-extract-plugin
export default {"container":"KgKC8I","headerContainer":"TmKxwX","commentCount":"WH05TG","text":"c_46I1","buttonContainer":"dUmGLw","errorCode":"YCH294"};